<ion-content class="ion-padding">
  <section class="h-full flex flex-col justify-center items-center text-center gap-3">
    <ion-icon size="large" name="cloud-download-outline"></ion-icon>

    <p class="font-semibold">
      {{ 'FORCED_UPDATE.TITLE' | translate }}
    </p>

    <p>
      {{ 'FORCED_UPDATE.BODY' | translate }}
    </p>

    @if (busy()) {
    <ion-button disabled>
      <ion-spinner name="circular"></ion-spinner>
    </ion-button>
    } @else {
    <ion-button (click)="update()">
      {{ (platform === 'ios' ? 'FORCED_UPDATE.BUTTON_IOS' : 'FORCED_UPDATE.BUTTON_ANDROID') | translate }}
    </ion-button>
    }

    <p class="text-sm opacity-60">
      {{ 'FORCED_UPDATE.VERSIONS' | translate : { installed: installed, required: required } }}
    </p>
  </section>
</ion-content>
